import { Oops } from '@stratumn/atomic';

import {
  ROUTE_BOT,
  ROUTE_BOTS,
  ROUTE_COLLABORATOR,
  ROUTE_COLLABORATORS,
  ROUTE_MEMBER,
  ROUTE_MEMBERS,
  ROUTE_MY_PROFILE,
  ROUTE_ORG,
  ROUTE_ORG_SETTINGS,
  ROUTE_TEAM,
  ROUTE_TEAMS
} from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import injectSheet from 'react-jss';
import {
  generatePath,
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import { withGqlClient, withUser } from 'wrappers';

import Bot from './bot';
import Bots from './bots';
import Collaborator from './collaborator';
import Collaborators from './collaborators';
import Member from './member';
import NotFound from './notFound';
import Organization from './organization';
import styles from './organization/organization.style';
import People from './people';
import Settings from './settings';
import Team from './team';
import Teams from './teams';

export const OrganizationLayout = ({
  classes,
  history,
  selectedOrganization
}) => {
  // There are some users that have unrealistic data so we need to account
  // for them to not crash the UI.
  const isUserInOrganization = !!(
    selectedOrganization && selectedOrganization.id
  );

  const renderNoOrganization = () => (
    <Oops
      description="You are not part of any organization"
      label="Go back to your profil"
      onHomeClick={() => {
        history.push(ROUTE_MY_PROFILE);
      }}
    />
  );

  const renderRoutes = () => (
    <Switch>
      <Route component={People} exact path={ROUTE_MEMBERS} />
      <Route component={Bots} exact path={ROUTE_BOTS} />
      <Route component={Teams} exact path={ROUTE_TEAMS} />
      <Route component={Collaborators} exact path={ROUTE_COLLABORATORS} />
      <Route component={Settings} exact path={ROUTE_ORG_SETTINGS} />
      <Route
        component={({
          match: {
            params: { id }
          }
        }) => <Team teamRowId={id} />}
        exact
        path={ROUTE_TEAM}
      />
      <Route
        component={({
          match: {
            params: { id, orgId }
          }
        }) => <Member memberRowId={id} orgRowId={orgId} />}
        exact
        path={ROUTE_MEMBER}
      />
      <Route
        component={({
          match: {
            params: { id }
          }
        }) => <Bot botRowId={id} />}
        exact
        path={ROUTE_BOT}
      />
      <Route
        component={({
          match: {
            params: { id, orgId }
          }
        }) => <Collaborator collaboratorRowId={id} orgRowId={orgId} />}
        exact
        path={ROUTE_COLLABORATOR}
      />

      {/* `/organization` (no org id) -> the selected organization's members. */}
      <Redirect
        exact
        from={ROUTE_ORG}
        to={generatePath(ROUTE_MEMBERS, {
          orgId: selectedOrganization.rowId
        })}
      />
      {/* `/organization/:orgId` (no section) -> that organization's members,
          resolved from the URL so it never lands on the wrong org. */}
      <Route
        exact
        path="/organization/:orgId"
        render={({ match }) => (
          <Redirect
            to={generatePath(ROUTE_MEMBERS, { orgId: match.params.orgId })}
          />
        )}
      />

      <Route component={NotFound} path="*" />
    </Switch>
  );

  return (
    <div className={classes.container}>
      <div className={classes.left}>
        {isUserInOrganization && <Organization />}
      </div>
      <div className={classes.right}>
        {isUserInOrganization ? renderRoutes() : renderNoOrganization()}
      </div>
    </div>
  );
};

OrganizationLayout.propTypes = {
  classes: PropType.object.isRequired,
  selectedOrganization: PropType.object
};

OrganizationLayout.defaultProps = {
  selectedOrganization: null
};

export default compose(
  withRouter,
  withGqlClient,
  withUser,
  injectSheet(styles)
)(OrganizationLayout);
